import * as React from "react";
import { useTranslation } from "react-i18next";

import { KnowledgeBaseSearch } from "./KnowledgeBaseSearch";
import styles from "./KnowledgeBaseView.scss";
import { KnowledgeBaseArticle } from "services/news/KnowledgeBaseService";

interface Props {
    selectedLanguage: string;
    onArticleClick: (article: KnowledgeBaseArticle) => void;
}

export const KnowledgeBaseWelcome: React.FC<Props> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <KnowledgeBaseSearch {...props} />

            <div className={styles.contentSection}>
                <div className={styles.helpCard}>
                    <div className={styles.helpCardContent}>
                        <h3>{t("KnowledgeBase.helpCardHeader")}</h3>
                        <p dangerouslySetInnerHTML={{ __html: t("KnowledgeBase.helpCardBody") }} />
                    </div>
                    <div className={styles.helpCardIcon}></div>
                </div>
            </div>
        </>
    );
};
